import { CHART_CATEGORIES } from 'constants/chart-categories';
import { generateVegaTooltip } from 'utils/chart/tooltips';
import { generateVegaNumberFormatExpression } from 'utils/number-formats';

export default {
  name: 'Number',
  displayName: 'Number',
  order: 1,
  flavour: 'discrete',
  category: CHART_CATEGORIES.TEXT,
  iconValue: 'number',
  channels: [
    {
      required: true,
      name: 'value',
      intent: 'value-axis',
      displayName: 'Number',
      channelType: 'aggregation',
    },
  ],
  specFn: (encodings, customisations) => {
    let valueCustoms = customisations.channels.value || {};
    // if numberFormatting doesn't exist, apply default format
    // this means chart is most likely created in old version of Charts
    valueCustoms = valueCustoms.numberFormatting
      ? valueCustoms
      : {
          ...valueCustoms,
          numberFormatting: { enabled: true, value: 'Default' },
        };
    const expr = generateVegaNumberFormatExpression(valueCustoms, true);
    return {
      data: [
        {
          name: 'transformedData',
          source: 'values',
          transform: [{ type: 'formula', as: 'formattedValue', expr }],
        },
      ],
      autosize: {
        type: 'fit',
        contains: 'padding',
      },
      marks: [
        {
          type: 'text',
          from: { data: 'transformedData' },
          encode: {
            enter: {
              x: { field: { group: 'width' }, mult: 0.5 },
              y: { field: { group: 'height' }, mult: 0.5 },
              font: { value: 'Akzidenz' },
              fontSize: {
                signal:
                  'min(height * 0.75, width * 2 / datum.formattedValue.length)',
              },
              baseline: { value: 'middle' },
              align: { value: 'center' },
              text: { field: 'formattedValue' },
              tooltip: {
                signal: generateVegaTooltip(encodings, {
                  ...customisations,
                  channels: { value: valueCustoms },
                }),
              },
            },
          },
        },
      ],
    };
  },
};
